import { http } from './http';

export interface ApiUser {
  id: number;
  userName: string;
  userFirstName: string;
  userLastName: string;
  userAccountEnabled: boolean;
  userIsDomain: boolean;
  userLastLogin?: string;
  departments?: string[];
  userGroups?: number[];
  // legacy pascal fallbacks accepted by backend
  UserGroups?: number[];
  Departments?: string[];
}

function normalizeUser(u: any): ApiUser {
  if (u.UserGroups && !u.userGroups) u.userGroups = u.UserGroups;
  if (u.Departments && !u.departments) u.departments = u.Departments;
  return u as ApiUser;
}

export async function getUsers(): Promise<ApiUser[]> {
  const data = await http<any[]>('/api/user');
  return Array.isArray(data) ? data.map(normalizeUser) : [];
}
export async function addUser(user: Omit<ApiUser,'id'>): Promise<ApiUser> { return normalizeUser(await http('/api/user',{method:'POST', json:user})); }
export async function updateUser(id: number, user: Omit<ApiUser,'id'>): Promise<ApiUser> { return normalizeUser(await http(`/api/user/${id}`, { method:'PUT', json:user })); }
export async function deleteUser(id: number): Promise<void> { await http(`/api/user/${id}`, { method:'DELETE' }); }
